import IBAN from "iban";
import TypeHelper from './TypeHelper';
export default {
    isNotNull(value)
    {
        return value !== null && value !== undefined && value !== '' || 'Bitte Feld ausfüllen';
    },
    requiresSelect(value)
    {
        return value !== null && value !== undefined && String(value).length > 0 || 'Bitte einen Wert wählen';
    },
    isEmail(value)
    {
        let regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regEx.test(value) || 'Bitte gültige E-Mail Adresse eingeben';
    },
    isIban(value)
    {
        return IBAN.isValid(value) || 'Bitte eine gültige IBAN eingeben';
    },
    requiresCheck(value)
    {
        return value !== null && value !== undefined && value === true || 'Bitte Angabe bestätigen';
    },
    runValidation(value, validators)
    {
        let validationResult = null;
        for (let i = 0; i < validators.length; i++)
        {
            let validatorResult = validators[i](value);
            validationResult = validatorResult === true ? null : validatorResult;

            //Stop validation when one validator returns errorMessage
            if (TypeHelper.isNotNullOrUndefined(validationResult))
                break;
        }

        return validationResult;
    }
}